export interface TraversalDiscoveryView {
  readonly label: string;
  readonly connection: string;
  readonly lockedMessage?: string;
}

export interface TraversalDiscoveryUi {
  show(view: Readonly<TraversalDiscoveryView>): void;
  hide(): void;
  dispose(): void;
}

export function createTraversalDiscoveryUi(root: HTMLElement): TraversalDiscoveryUi {
  const panel = document.createElement("aside");
  panel.className = "traversal-discovery";
  panel.hidden = true;
  panel.setAttribute("aria-live", "polite");
  panel.setAttribute("aria-atomic", "true");
  const eyebrow = document.createElement("p");
  eyebrow.className = "traversal-discovery-eyebrow";
  const label = document.createElement("p");
  label.className = "traversal-discovery-label";
  const connection = document.createElement("p");
  connection.className = "traversal-discovery-connection";
  panel.append(eyebrow, label, connection);
  root.append(panel);

  return {
    show(view): void {
      panel.hidden = false;
      eyebrow.textContent = view.lockedMessage === undefined
        ? "Route discovered"
        : "Locked shortcut";
      label.textContent = view.label;
      connection.textContent = view.lockedMessage ?? view.connection;
    },
    hide(): void {
      panel.hidden = true;
    },
    dispose(): void {
      panel.remove();
    },
  };
}

